// После АБ теста - удалить, а также ABAnimationFortune и ABAnimationAva, а также npm react-confetti

import Loader from "@Common/Loader";
import { getOfferType, isLightOffer } from "@Common/OfferLight/helpers.js";
import { useHandleResize, useClickOutside, useLoadComponents, loadLazyComponent } from "@hook";
import { clearParamWithoutRerender, getSqlServerGuidHash, sendMetric, getWhatId, getAbTestMetrika, isTempHiddenOfferTypeSite } from "@utils";

import { inject, observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import close_circle from "./img/close-circle.svg";
import close_geo from "./img/close_geo.svg";
import modal_close_2 from "./img/modal_close_2.svg";
import modal_close_2_mobile from "./img/modal_close_2_mobile.svg";

const modals = {
    offer: loadLazyComponent(() => import("../../../components/Modal/OfferModal")),
    promo: loadLazyComponent(() => import("../../../components/Modal/PromoModal")),
    "ava-wheel": loadLazyComponent(() => import("../../../components/Modal/AvaWheelModal")),
    fortune: loadLazyComponent(() => import("../../../components/Modal/FortuneModal")),
    ghost: loadLazyComponent(() => import("../../../components/Modal/GhostModal")),
    cpc: loadLazyComponent(() => import("../../../components/Modal/CPCModal")),
    fortuneNew: loadLazyComponent(() => import("../../../components/Modal/WheelOfFortune")),
    koleso: loadLazyComponent(() => import("../../../components/Modal/AvaWheelModalWheel")),
    ai: loadLazyComponent(() => import("../../../components/Modal/AIModal")),
    face: loadLazyComponent(() => import("../../../components/Modal/Face")),
    geolocationUser: loadLazyComponent(() => import("../../../components/Modal/GeolocationUser")),
    recommendation: loadLazyComponent(() => import("../../../components/Modal/RecommendationModal")),
    ab_2659: loadLazyComponent(() => import("../../../components/Modal/AB_2659")),
};

const { VITE_WHAT_ID } = import.meta.env;

const types = ["ava-wheel", "fortune", "face", "koleso", "fortuneNew"];
const PRELOAD_DESKTOP_MODAL_KEYS = Object.keys(modals);
const PRELOAD_MOBILE_MODAL_KEYS = ["ava-wheel", "fortune", "fortuneNew", "koleso", "ai", "face", "cpc", "geolocationUser"];
const PRELOAD_CONTROL_DESKTOP_MODAL_KEYS = PRELOAD_DESKTOP_MODAL_KEYS.filter((key) => !["geolocationUser", "ab_2659"].includes(key));
const PRELOAD_CONTROL_MOBILE_MODAL_KEYS = PRELOAD_MOBILE_MODAL_KEYS.filter((key) => key !== "geolocationUser");

import "@Common/OfferLight/style.scss";
import "./style.scss";

const Default = inject("mainStore")(
    observer(({ mainStore }) => {
        const modal = mainStore.getMainStore("modal");
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const settingLego = mainStore.getMainStore("settingLego");
        const isControlTheme = mainStore.getMainStore("theme") === "ab-control";

        const nodeRef = useRef();

        const { type, offerItem } = modal;
        const showOfferLight = ["offer", "promo"].includes(type) && isLightOffer(offerItem);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const location = useLocation();
        const isMobile = useHandleResize();
        const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);
        const preloadKeys = isControlTheme ? (isMobile ? PRELOAD_CONTROL_MOBILE_MODAL_KEYS : PRELOAD_CONTROL_DESKTOP_MODAL_KEYS) : isMobile ? PRELOAD_MOBILE_MODAL_KEYS : PRELOAD_DESKTOP_MODAL_KEYS;

        const activeModals = useLoadComponents(modals, preloadKeys);
        const isLoaded = preloadKeys.every((key) => activeModals[key]);

        useClickOutside(type, nodeRef, types.includes(type) ? () => {} : () => handleCloseModal());

        const itType = (!isTempHiddenOfferTypeSite(what_id) && offerItem && getOfferType(offerItem)) || false; // DEV-4295

        const Specified = type && (!isControlTheme || !["geolocationUser", "ab_2659"].includes(type)) && activeModals[type] ? activeModals[type] : false;

        useEffect(() => {
            let body = document.body;
            if (body && Specified) {
                body.style.overflow = "hidden";
                body.style["touch-action"] = "none";
                body.style["-webkit-overflow-scrolling"] = "none";
                body.style["overscroll-behavior"] = "none";
                body.style.width = "100%";
            } else {
                body.style = {};
            }
        }, [Specified, isMobile]); // isMobile чтобы срезать стили для блокировки скрола на мобильном устройстве

        const handleCloseModal = () => {
            clearParamWithoutRerender(["id", "code", "noym"]);
            mainStore.setMainStore("modal", false);
            mainStore.setMainStore("promoIdCity", false);
            mainStore.setMainStore("promoIdRegion", false);
            mainStore.setMainStore("promoIdMetro", false);

            if (type === "offer") {
                if (!localStorage.getItem("first_click_offer_close")) {
                    sendMetric(`first_click_offer_close`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    localStorage.setItem("first_click_offer_close", true);
                }
                sendMetric(`click_offer_close`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
            }

            if (type === "promo" || type === "ghost") {
                sendMetric(`click_offer_accepted_close`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
            }
        };

        // не показываем модалку если это мобильный телефон и есть айдишка на открытие офера напрямую
        if (isMobile && type !== "cpc" && type !== "geolocationUser") {
            const searchParams = new URLSearchParams(location.search);
            const id = searchParams.get("id");
            if (id) return;
        }
        // не показываем модалку если это мобильный телефон и есть айдишка на открытие офера напрямую

        const modalBgColor = settingLego?.bgColor === "palette" ? "var(--color2)" : "var(--color4)";

        return type && !isLoaded ? (
            <div className="modal-loader">
                <Loader />
            </div>
        ) : Specified ? (
            <div className={`modal  ${Specified ? "show-modal" : ""} ${type}`} style={{ "--bgColor": modalBgColor }}>
                <div ref={nodeRef} id="modal-container" className={`modal__content ${type} ${itType ? itType : ""} ${showOfferLight ? "offer-light" : ""}`}>
                    {showOfferLight || itType === "special" ? <span className="hit-label special">спецпроект</span> : itType === "hit" ? <span className="hit-label hit">{offerItem.typeLabel || "хит"}</span> : null}
                    {type == "ava-wheel" || type == "fortune" || type == "fortuneNew" || type == "koleso" || type === "face" || type === "geolocationUser" ? null : (
                        <>
                            <img src={modal_close_2} className="modal__content_close cursor" onClick={() => handleCloseModal()} />
                            <img src={modal_close_2_mobile} className="modal__content_close_mobile" onClick={() => handleCloseModal()} />
                        </>
                    )}
                    {type === "geolocationUser" ? <img className="modal__content_close_geo mobile" src={close_circle} onClick={() => handleCloseModal()} /> : null}
                    {type === "geolocationUser" ? <img className="modal__content_close_geo" src={close_geo} onClick={() => handleCloseModal()} /> : null}

                    {Specified ? <Specified modal={modal} /> : null}
                </div>

                {type === "promo" ? (
                    <div className={`promo_button `} onClick={() => handleCloseModal()}>
                        Выбрать больше подарков +
                    </div>
                ) : null}
            </div>
        ) : null;
    }),
);

export default Default;
